import { ACTIONS } from "../../enums/actions";

export const getRegion = (
  payload: any,
  onSuccess?: (data: any) => void,
  onFail?: (data: any) => void
) => ({
  type: ACTIONS.GET_REGION,
  payload,
  onSuccess: onSuccess || null,
  onFail: onFail || null,
});

export const getAllRegion = (
  payload: any,
  onSuccess?: (data: any) => void,
  onFail?: (data: any) => void
) => ({
  type: ACTIONS.GET_ALL_REGION,
  payload,
  onSuccess: onSuccess || null,
  onFail: onFail || null,
});

export const createRegion = (
  payload: any,
  onSuccess?: Function,
  onFail: Function | null = null
) => ({
  type: ACTIONS.CREATE_REGION,
  payload,
  onSuccess: onSuccess || null,
  onFail: onFail || null,
});

export const updateRegion = (
  payload: any,
  onSuccess?: Function,
  onFail: Function | null = null
) => ({
  type: ACTIONS.UPDATE_REGION,
  payload,
  onSuccess: onSuccess || null,
  onFail: onFail || null,
});

export const deleteRegion = (
  payload: any,
  onSuccess?: Function,
  onFail?: Function
) => ({
  type: ACTIONS.DELETE_REGION,
  payload,
  onSuccess: onSuccess || null,
  onFail: onFail || null,
});
